import InvestmentsTransferModal from "./InvestmentsTransferModal";

export default InvestmentsTransferModal;
